import { ActionGridInput } from 'models/order-input/shared';

export const emptyActionInput = () => {
    return {
        _id: '',
        actionCode: '',
        description: '',
        quantity: '',
        unitPrice: '',
        tiotandvardPrice: '',
        vatPercent: '',
        priceWithoutVat: 0,
        priceWithVat: 0,
        category: '',
        isValid: true,
    } as ActionGridInput;
};

export const isActionRowEmpty = (action: ActionGridInput) => {
    return Object.values(action).every((v) => v === '' || v === null || v === undefined || v === true || v === 0);
};
